import * as React from "react";
const SvgArrowDown = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 54 54", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m54 14.994-23.07 23.927.07.073-3.96 3.956-.05.057-3.99-4.013.07-.074-23.07-23.926 4-4 23 23.852 23-23.852z" }));
export default SvgArrowDown;
